export default (req1, req2) => {
  return req1.name.localeCompare(req2.name);
};
